import { PostHogEventTrackingProvider } from "@/lib/event-tracking/post-hog/post-hog-provider";
import type { User } from "@/types";

export const EventTrackingProvider = ({ user }: { user: User | null }) => {
  if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
    return <PostHogEventTrackingProvider user={user} />;
  }

  return null;
};
